import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../../styles/SubHeader.css';

function SubHeader({ title, showBack = true, rightAction }) {
  const navigate = useNavigate();

  return (
    <header className="sub-header">
      <div className="sub-header-content">
        {showBack && (
          <button 
            className="sub-header-back"
            onClick={() => navigate(-1)}
            aria-label="Quay lại"
          >
            <FontAwesomeIcon icon={faArrowLeft} />
          </button>
        )}
        
        <h1 className="sub-header-title">{title}</h1>
        
        {rightAction && (
          <div className="action-button">
            {rightAction}
          </div>
        )}
      </div>
    </header>
  );
}

export default SubHeader;
